var App = App || {};

App.SlipOpinionsList = (function ($) {
    "use strict";

    function init() {
        const SlipOpinionsListBlock = $(".block.slip-opinions-list");
        const inactiveClass = "hidden";

        if (SlipOpinionsListBlock.length) {
            SlipOpinionsListBlock.each(function () {
                var thisBlock = $(this);
                var expandAllBtn = thisBlock.find(".btn.expand-all");
                var collapseAllBtn = thisBlock.find(".btn.collapse-all");
                var defaultHiddenSection = thisBlock.find(".accordion-item-group.default-hidden");
                var indicator = thisBlock.find(".page-indicator");
                var total = parseInt(indicator.data("total"), 10) || 0;

                function renderIndicator(end) {
                    
                    indicator.html(`1 - <span class="shown-items-count">${end}</span> of ${total} items`);
                }

                expandAllBtn.on("click", function () {
                    //show
                    defaultHiddenSection.removeClass(inactiveClass);
                    collapseAllBtn.removeClass(inactiveClass);

                    //hide
                    expandAllBtn.addClass(inactiveClass);

                    var end = parseInt(thisBlock.attr("data-list-count"), 10) || 0;
                    renderIndicator(end);
                });

                collapseAllBtn.on("click", function () {
                    //hide
                    defaultHiddenSection.addClass(inactiveClass);
                    collapseAllBtn.addClass(inactiveClass);

                    //show
                    expandAllBtn.removeClass(inactiveClass);

                    var end = parseInt(thisBlock.attr("data-show-more"), 10) || 0;
                    renderIndicator(end);
                });
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SlipOpinionsList.init();
});